import { useEffect, useState } from "react";
import { clockConfig, formatClock } from "@/player/lib/widgets";

/** Fullscreen clock: big time, small date. tz from config, else device-local. */
export function ClockWidget({
  config,
}: {
  config: Record<string, unknown> | null;
}) {
  const cfg = clockConfig(config);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const { time, date } = formatClock(now, cfg);
  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center gap-4 bg-background"
      data-testid="widget-clock"
    >
      <div className="font-semibold tabular-nums tracking-tight text-foreground text-[18vw] leading-none">
        {time}
      </div>
      <div className="text-muted-foreground text-[3.5vw]">{date}</div>
    </div>
  );
}
